import { TableRenderer, TableRenderType } from "../../../shared/components/edit-table/table-renderer";
import { JsonItem } from "../../../shared/entities/pick-list/pick-list.entities";
import { getDisplayDate, getMonthYearDisplay } from "../../../shared/scripts/date-functions";
import { CabHubCompletedSurveyRow } from "./cab-hub-tracking.entities";


export class CompletedSurveyViewModal {
    modalId: string;
    tableRenderer: TableRenderer;
    pickLists: JsonItem[];

    constructor(modalId: string, pickLists: JsonItem[]) {
        this.modalId = modalId;
        this.pickLists = pickLists;
        this.tableRenderer = new TableRenderer(pickLists);
    }

    openModal(survey: CabHubCompletedSurveyRow, type: CompletedSurveyViewType): void {
        this.generateModalHtml(survey, type);
        $(`#${this.modalId}`).modal("show");
    }

    private generateModalHtml(survey: CabHubCompletedSurveyRow, type: CompletedSurveyViewType): void {
        let closeRow = `
            <div class="edit-item-modal-close-row">
                <div class="d-flex justify-content-end">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true"><i class="fa-solid fa-xmark"></i></span>
                    </button>
                </div>
            </div>
        `;

        let displayTitle = "";
        if (type == CompletedSurveyViewType.CAB) {
            displayTitle = "Submitted CAB Survey";
        }
        else if (type == CompletedSurveyViewType.Hub) {
            displayTitle = "Submitted Hub Survey";
        }

        let headerRow = `
            <div class="edit-item-modal-header-row">
                <div class="d-flex" style="flex-direction: row-reverse;">
                    <div class="col edit-item-overview-block">
                        <div class="edit-item-title mt-2">
                            ${displayTitle}
                        </div>
                    </div>
                </div>
            </div>
        `;

        let modalBody = `
            <div class="edit-item-modal-body">
                <div class="view-item-modal-container">
                    ${this.generateModalBody(survey, type)}
                </div>
            </div>
        `;

        let modalFooter = `
            <div class="edit-item-modal-footer">
                <button type="button" class="butn white" data-dismiss="modal" aria-label="Close">
                    <span>Close</span>
                </button>
            </div>
        `;

        let html = `
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    ${closeRow}
                    ${headerRow}
                    ${modalBody}
                    ${modalFooter}
                </div>
            </div>
        `;

        $(`#${this.modalId}`).empty().html(html);
    }

    private generateModalBody(survey: CabHubCompletedSurveyRow, type: CompletedSurveyViewType): string {
        const satisfaction = this.tableRenderer.renderDisplay(survey.SatisfactionRatingId, TableRenderType.Number, "SatisfactionRating");
        const anticipatedHours = this.tableRenderer.renderDisplay(survey.AnticipatedHoursNextMonthId, TableRenderType.Number, "YesNoNotSure");
        const trainingNeeded = this.tableRenderer.renderDisplay(survey.TrainingNeededId, TableRenderType.Number, "YesNoNotSure");

        const consultationTypes = this.tableRenderer.renderDisplay(survey.ConsultationTypeIds, TableRenderType.PipePathSeparatedIds, survey.SurveyType === "CAB" ? "CabConsultationType" : "HubConsultationType");
        const submittedBy = survey.SubmittedByName;

        let modalBody = `   
            <div class="row">
                ${this.renderSurveyDetail("Survey Type", type == CompletedSurveyViewType.CAB ? "CAB" : "Hub")}
                ${this.renderSurveyDetail("CAB Member", survey.CabMemberName)}
                ${this.renderSurveyDetail("Hub", survey.HubShortName)}
                ${this.renderSurveyDetail("Reporting Period", getMonthYearDisplay(survey.ReportingMonth, survey.ReportingYear))}

                ${this.renderSurveyDetail("Met This Month", this.renderSurveyPill(survey.MetThisMonth ? "Yes" : "No"), true)}
                ${this.renderSurveyDetail("Not Met Explanation", survey.NotMetExplanation)}

                ${this.renderSurveyDetail("Hours Worked", survey.HoursWorked)}
                ${this.renderSurveyDetail("Additional Hours Compensation Rate", survey.AdditionalHoursCompensationRate != null && survey.AdditionalHoursCompensationRate > 0 ? `$${survey.AdditionalHoursCompensationRate}` : null)}
                ${this.renderSurveyDetail("Anticipated Hours Next Month", anticipatedHours)}
                ${this.renderSurveyDetail("Consultation Types", consultationTypes)}
                ${this.renderSurveyDetail("Other Consultation Type", survey.OtherConsultationType)}

                ${this.renderSurveyDetail("Work Description", survey.WorkDescription)}

                ${this.renderSurveyDetail("Satisfaction", satisfaction)}
                ${this.renderSurveyDetail("Satisfaction Explanation", survey.SatisfactionExplanation)}

                ${this.renderSurveyDetail("Support Requested", this.renderSurveyPill(survey.SupportRequested ? "Yes" : "No", true), true)}
                ${this.renderSurveyDetail("Support Request Explanation", survey.SupportRequestExplanation)}

                ${this.renderSurveyDetail("Training Needed", this.renderSurveyPill(trainingNeeded, true), true)}
                ${this.renderSurveyDetail("Training Description", survey.TrainingDescription)}

                ${this.renderSurveyDetail("Submitted By", submittedBy)}
                ${this.renderSurveyDetail("Submitted", survey.SubmittedDate ? getDisplayDate(new Date(survey.SubmittedDate)) : null)}
            </div>
        `;

        return modalBody;
    }

    private renderSurveyDetail(label: string, value: any, isHtml: boolean = false): string {

        const displayValue = isHtml ? value : this.formatSurveyValue(value);

        return `
            <div class="col-12 col-md-6 py-3 completed-survey-detail">
                <div class="completed-survey-detail-label">
                    ${label}
                </div>

                <div class="completed-survey-detail-value">
                    ${displayValue}
                </div>
            </div>
        `;
    }

    private formatSurveyValue(value: any): string {
        if (value === null || value === undefined || value === "") {
            return "—";
        }

        return String(value);
    }

    private renderSurveyPill(value: string, inverse: boolean = false): string {
        const normalizedValue = (value ?? "").trim().toLowerCase();
        let pillClass = "cab-view-table-inactive-pill";
        if (inverse) {
            pillClass = "cab-edit-table-active-pill";
        }

        if (normalizedValue === "yes" || normalizedValue === "satisfied" || normalizedValue === "extremely satisfied") {        
            if (inverse) {
                pillClass = "cab-view-table-inactive-pill";
            }
            else {
                pillClass = "cab-edit-table-active-pill";
            }
        }
        else if (normalizedValue === "not sure" || normalizedValue === "neither satisfied or dissatisfied") {
            pillClass = "cab-detail-table-neutral-pill";
        }

        return `<span class="${pillClass}">${this.formatSurveyValue(value)}</span>`;
    }
}

export enum CompletedSurveyViewType {
    CAB,
    Hub
}